import React from "react";
import "./joyride.css";
import Dialog from "material-ui/Dialog";

// Entries flagged with this sentinel render as un-numbered headings.
const HEADING_MARK = "<!--HEADING-->";

const TnCDialog = ({ termsnConditions, onClose }) => {
  // Number only non-heading entries so headings don't consume a number and the
  // sequence stays continuous across them (incl. the two trailing contact lines).
  let counter = 0;
  const items = termsnConditions.map((t) => {
    const raw = String(t);
    const isHeading = raw.includes(HEADING_MARK);
    const html = isHeading ? raw.replace(HEADING_MARK, "") : `${(counter += 1)}. ${raw}`;
    return { html, isHeading };
  });

  return (
    <Dialog
      title="Terms Of Service"
      autoScrollBodyContent={true}
      open={!!termsnConditions.length}
      onRequestClose={onClose}
    >
      <div style={{ paddingTop: "10px" }}>
        {items.map((item, index) => (
          <div key={index}>
            <p dangerouslySetInnerHTML={{ __html: item.html }} />
          </div>
        ))}
        <div>
          <p>
            {counter + 1}. In case of any query please contact at
            info@helitaxii.com or 9400399999
          </p>
        </div>
        <div>
          <p>
            {counter + 2}. After booking your tickets will be shared via email
            within 30 minutes of the payment confirmation. If not received after
            30 minutes of payment, please check your spam folder or email at
            Info@helitaxii.com
          </p>
        </div>
      </div>
    </Dialog>
  );
};

export default TnCDialog;
